import React from 'react';
import { useRicosTheme } from '../../theme/ricos-theme-utils';
import RicosViewer from '../ricos-viewer/ricos-viewer';
import styles from './field-description-wut.module.scss';
const RICOS_THEME = {
    customStyles: {
        p: {
            fontSize: 'var(--wix-forms-formInputNoteFont-size)',
            fontFamily: 'var(--wix-forms-formInputNoteFont-family)',
            color: 'rgb(var(--wix-forms-formInputNoteColor, 0,0,0))'
        }
    }
};
export const FieldDescriptionWUT = ({ description, id })=>{
    const customTheme = useRicosTheme(RICOS_THEME);
    return description ? /*#__PURE__*/ React.createElement("div", {
        className: styles.description,
        id: id
    }, /*#__PURE__*/ React.createElement(RicosViewer, {
        content: description,
        customTheme: customTheme
    })) : null;
};

//# sourceMappingURL=field-description-wut.js.map